import React from "react";
import { IconButton } from "@mui/material";
import { DeleteIcon } from "components/icon";
import { StyledButton } from "customStyled";
import DeleteConfirmDialog from "./DeleteConfirmDialog";
import { useTranslation } from "react-i18next";

const DeleteConfirmDialogWB = (props) => {
  const { t } = useTranslation();
  const {
    onSubmit = () => null,
    onCancel = () => null,
    variant = "text",
    fetchFunc = null,
    withConfirmation = true,
  } = props;
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = async (e) => {
    e.preventDefault();
    if (!!fetchFunc) {
      const res = await fetchFunc();
      if (!res) {
        return;
      }
    }
    if (withConfirmation) {
      setOpen(true);
    } else {
      onSubmit();
    }
  };

  const handleClose = (value) => {
    setOpen(false);
    if (value === null) {
      onCancel();
    } else {
      onSubmit();
    }
  };

  return (
    <React.Fragment>
      {props.buttonText ? (
        <StyledButton
          variant={variant}
          color="error"
          startIcon={<DeleteIcon />}
          onClick={handleClickOpen}
          sx={{
            flexDirection: "row",
            alignSelf: "flex-start",
            zIndex: 11,
          }}
        >
          {props.buttonText}
        </StyledButton>
      ) : (
        <IconButton
          sx={{ zIndex: 11 }}
          onClick={handleClickOpen}
          aria-label={typeof props.title === "string" ? props.title : t("delete")}
        >
          <DeleteIcon sx={{ color: "#BC1B06" }} />
        </IconButton>
      )}
      {withConfirmation ? (
        <DeleteConfirmDialog open={open} onClose={handleClose} {...props} />
      ) : null}
    </React.Fragment>
  );
};

export default DeleteConfirmDialogWB;
